import React, { useContext } from "react";
import { Link  } from 'react-router-dom';
import { AuthContext } from "../store/AuthContext";
import { Button } from 'react-bootstrap';

const LogoutModal = () => {
    const { handleLogout } = useContext(AuthContext);
        
    return (
      <>
       
       <Link className="scroll-to-top rounded" to={"#page-top"}>
          <i className="fas fa-angle-up"></i>
       </Link>
       
       
        <div className="modal fade" id="logoutModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Pronto para partir?</h5>
                        <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">Selecione "Logout" abaixo se você estiver pronto para encerrar sua sessão atual.</div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary" type="button" data-dismiss="modal">Cancelar</button>
                        <Button className="btn btn-primary" onClick={handleLogout}> Logout </Button>
                    </div>
                </div>
            </div>
        </div> 
      </>
    )
}

export default LogoutModal
